import { asce716and722BuildingCode, asce722BuildingCodeSM, asceBuildingCodeSMForAurora } from 'projectDesign/components/projectConfiguration/fields/buildingCode';
import {smBuildingHeight, buildingHeightMetric, buildingHeightSMFamilyNonAscenderFlushMetric} from 'projectDesign/components/projectConfiguration/fields/buildingHeight';
import clientName from 'projectDesign/components/projectConfiguration/fields/clientName';
import clientAddress from 'projectDesign/components/projectConfiguration/fields/clientAddress';
import smElevation, { elevationMetric } from 'projectDesign/components/projectConfiguration/fields/elevation';
import smRafterSpacing, {rafterSpacingMetric} from 'projectDesign/components/projectConfiguration/fields/rafterSpacing';
import railDirection from 'projectDesign/components/projectConfiguration/fields/railDirection';
import {railFinish  as smRailFinish, ascenderRailFinish} from 'projectDesign/components/projectConfiguration/fields/railFinish';
import {smAscenderFlushRoofType, smFlushRoofType } from 'projectDesign/components/projectConfiguration/fields/roofType';
import seismicSs from 'projectDesign/components/projectConfiguration/fields/seismicSs';
import smSnowLoad, {snowLoadMetric, SmAndNxtSnowLoadConfig, SmAndNxtSnowLoadMetric} from 'projectDesign/components/projectConfiguration/fields/snowLoad';
import smPreferredSpan, { preferredSpanMetric } from 'projectDesign/components/projectConfiguration/fields/span';
import {WindExposure} from 'projectDesign/components/projectConfiguration/fields/windExposure';
import { asce705WindSpeedForSfmAndSm, asce710WindSpeedForSfmAndSm, asce716WindSpeedMetric, asce716WindSpeedForSfmAndSm_nxt, } from 'projectDesign/components/projectConfiguration/fields/windSpeed';
import { checkEnvironmentalFactors } from 'projectDesign/components/projectConfiguration/utils/checkEnvironmentalFactors';
import { checkRafterSpacing, checkSeismic, checkShortestBuildingLength, checkBuildingHeight, checkSnowLoadLimit, checkTornadoSpeed, checkSeismicSds, checkFieldNotEmpty, checkRoofTypeMissing, checkPreferredSpan } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/validateProject';
import { state } from '__common/store';
import { isASCE705, isASCE710, isASCE716or722, isASCE722 } from '__common/constants/buildingCodes';
import { ascenderMidAndEndClamps, smMidAndEndClamps } from 'projectDesign/components/projectConfiguration/fields/smClamps';
import { smTileReplacementsOrSolarhooks, TileAttachmentType } from '../fields/smTileReplacementsOrSolarhooks';
import smStandardSeamMetalAttachment from '../fields/smStandardSeamMetalAttachment';
import roofMaterialThicknessSolarMountFlush, { rpanelRoofMaterialThicknessForPM9000s, rpanelRoofMaterialThicknessForPMAdj } from '../fields/roofMaterialThicknessSolarMountFlush';
import smSolarhooksAttachments from '../fields/smSolarhooksAttachments';
import { RoofType, removeUpslopeRail } from '../utils/constants';
import topographicalFactorKzt from '../fields/topographicalFactorKzt';
import { AttachmentType, smAndNxtAttachmentTypes,  } from '../fields/attachmentType';
import { roofSubstrate } from '../fields/roofSubstrate';
import { isOsbOrPlywood } from '../utils/validation';
import { isSM2Standard, isSMAscenderFlush, isSMLT } from '__common/constants/products';
import smShortestBuildingLength, {shortestBuildingLengthMetric, shortestBuildingLengthSMFamilyNonAscenderFlushMetric} from 'projectDesign/components/projectConfiguration/fields/shortestBuildingLength';
import residentalBuildingTypes from 'projectDesign/components/projectConfiguration/fields/residentalBuildingTypes';
import { isMetricUnit } from 'engineering/components/engineeringProjectDocuments/utils/unitTypes';
import { getASCE716722LocationsResidentalAdditionalInputs } from '../fields/getASCE716LocationsResidentalAdditionalInputs';
import { isSMAscenderFlushMetric } from '__common/utils/products';
import azimuth from 'projectDesign/components/projectConfiguration/fields/helioscope_azimuth.json';
import frameSizeUp from 'projectDesign/components/projectConfiguration/fields/helioscope_frame_size_up.json';
import frameSizeWide from 'projectDesign/components/projectConfiguration/fields/helioscope_frame_size_wide.json';
import orientation from 'projectDesign/components/projectConfiguration/fields/helioscope_orientation.json';
import racking from 'projectDesign/components/projectConfiguration/fields/helioscope_racking.json';
import setSpacing from 'projectDesign/components/projectConfiguration/fields/helioscope_setback.json';
import seismicSds from 'projectDesign/components/projectConfiguration/fields/seismicSds';
import tornadoSpeed, { metricTornadoSpeedField } from 'projectDesign/components/projectConfiguration/fields/tornadoSpeed';
import { riskCategoryCheckForTornadoSpeed } from '../constraints/constraints';
import { longestBuildingLengthField as longestBuildingLength } from '../fields/longestBuildingLength';
import riskCategory from '../fields/riskCategory';
import StaggerAttachments from 'projectDesign/components/projectConfiguration/fields/staggerAttachments';
import { PSEUDO_STAFF_USER_PERMISSIONS } from 'user/userGroups';
import auroraRackingType from '../fields/auroraRackingType';
import { getProjectRoofs } from 'projectDesign/components/asce716switch/asce716switch';
import domesticMLPERequired from '../fields/isDomesticMLPERequired';
import domesticContent from '../fields/isDomesticContent';
import standoffHeight from '../fields/standoffHeight';
import osRackingType from '../fields/osRackingType';
import getS5manufacturer from '../fields/s5RoofManufacturerField'
import getS5RoofPanel from '../fields/s5RoofPanelField';
import getS5RoofMaterial from '../fields/s5RoofMaterialField';
import getS5Clamp from '../fields/s5ClampField';
import s5Attachmentpreference from '../fields/s5AttachmentpreferenceField';
import { extractUniqueS5Values, filterDataByFields, getS5DataValue, isGeneric, s5AttachmentDictKeys, s5AttachmentPreferenceDict, s5AttachmentsData } from '../utils/s5AttachmentsFilters';

const getWindSpeedField = (buildingCodeValue: number, inputUnit?: number, isAurora?: boolean, isOs?: boolean) => {
  if(isMetricUnit(inputUnit)) {
    return asce716WindSpeedMetric(false);
  }
  else if (isASCE705(buildingCodeValue)) {
    return asce705WindSpeedForSfmAndSm(isAurora, isOs);
  }
  else if (isASCE710(buildingCodeValue)) {
    return asce710WindSpeedForSfmAndSm(isAurora, isOs);
  }
  else return asce716WindSpeedForSfmAndSm_nxt(isAurora, isOs);
}

export default (buildingCodeValue: number) => {

  const {
    projectConfiguration: {
      railsProductId,
      projectEnvConfig: {
        seismic_ss, seismic_sds, tornado_speed, roof_type,
        tile_replacement_or_solarhooks,
        attachment_type,
        roof_substrate,
        building_height,
        shortest_building_length,
        snow_load,
        rafter_spacing_inches,
        risk_category,
        building_length,
        elevation: current_elevation,
        wind_speed,
        is_aurora_project,
        is_os_project,
        topographical_factor_kzt,
        s5_roof_manufacturer,
        s5_roof_panel,
        s5_roof_material,
        s5_clamp,
        s5_or_sci,
        preferred_span,
        domestic_content,
      },
      inputUnit,
      productId, projectVersion
    },
    user : { isPrivilegedUser, isStaff, permissions },
  } = state();

  const roofs = getProjectRoofs();
  let isOneByTwelvePitch = () =>{
    if (roofs) {
      return Object.keys(roofs).some(roofKey => {
        const roofId = Number(roofKey)
        const roof: drawingManagerRoof = roofs[roofId]
        return roof.roofPitch === '1/12'        
      })
    }
  }
  
  const buildingCodeField = isSMAscenderFlush(railsProductId) ? asce716and722BuildingCode(is_aurora_project, is_os_project, productId) : ((is_aurora_project && isOneByTwelvePitch()) ? asceBuildingCodeSMForAurora() : asce722BuildingCodeSM(is_aurora_project, is_os_project, productId));
  const windSpeed = getWindSpeedField(buildingCodeValue, inputUnit, is_aurora_project, is_os_project);
  const windExposureField = WindExposure(is_os_project);
  const railFinish = isSMAscenderFlush(railsProductId) ? ascenderRailFinish: smRailFinish; 
  const snowLoad = isMetricUnit(inputUnit) ? SmAndNxtSnowLoadMetric(is_aurora_project, is_os_project) : SmAndNxtSnowLoadConfig(is_aurora_project, is_os_project);
  const elevation = isMetricUnit(inputUnit) ? elevationMetric : smElevation;
  const preferredSpan = isMetricUnit(inputUnit) ? preferredSpanMetric : smPreferredSpan;
  const shortestBuildingLength = isMetricUnit(inputUnit) ? isSMAscenderFlushMetric() ? shortestBuildingLengthMetric: shortestBuildingLengthSMFamilyNonAscenderFlushMetric: smShortestBuildingLength;
  const buildingHeight = isMetricUnit(inputUnit) ? isSMAscenderFlushMetric() ? buildingHeightMetric: buildingHeightSMFamilyNonAscenderFlushMetric : smBuildingHeight(is_aurora_project, is_os_project);
  const rafterSpacing = isMetricUnit(inputUnit) ?  rafterSpacingMetric(roof_type): smRafterSpacing(roof_type);
  const roofType = isSMAscenderFlush(railsProductId) ? smAscenderFlushRoofType : smFlushRoofType;

  const shouldShowS5AttachmentFields = (roof_type === RoofType.STANDING_SEAM) && (s5_or_sci === s5AttachmentPreferenceDict.s_5)

  let s5RoofManufacturer;
  let s5RoofPanel;
  let s5RoofMaterial;
  let s5Clamp;
  let selectedS5Manufacturer = s5_roof_manufacturer;
  let selectedS5Panel = s5_roof_panel;
  let selectedS5Material = s5_roof_material;
  let hasSelectedS5Manufacturer = false;
  let hasSelectedS5Panel = false;
  let hasSelectedS5Material = false;

  if(shouldShowS5AttachmentFields){
    selectedS5Manufacturer = getS5DataValue(s5AttachmentsData, s5AttachmentDictKeys.s_5_roof_manufacturer, s5_roof_manufacturer);
    const filteredMfValues = extractUniqueS5Values(s5AttachmentsData, s5AttachmentDictKeys.s_5_roof_manufacturer);
    filteredMfValues.unshift(isGeneric)
    s5RoofManufacturer = getS5manufacturer(filteredMfValues)

    const s5RoofPanelTypeData = filterDataByFields(s5AttachmentsData, (selectedS5Manufacturer === isGeneric) ? '' : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer})
    const filteredpanelTypeValues = extractUniqueS5Values(s5RoofPanelTypeData, s5AttachmentDictKeys.s_5_roof_panel_type)
    if(selectedS5Manufacturer === isGeneric) {
      filteredpanelTypeValues.unshift(isGeneric)
    }
    hasSelectedS5Manufacturer = checkFieldNotEmpty(selectedS5Manufacturer) && filteredpanelTypeValues.length > 0;
    s5RoofPanel = getS5RoofPanel(filteredpanelTypeValues)

    selectedS5Panel = getS5DataValue(s5RoofPanelTypeData, s5AttachmentDictKeys.s_5_roof_panel_type, s5_roof_panel);
    const s5RoofMaterialData = filterDataByFields(s5RoofPanelTypeData, (selectedS5Panel === isGeneric) ? ''  : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer, [s5AttachmentDictKeys.s_5_roof_panel_type] : selectedS5Panel,})
    const filteredRoofMaterialValues = extractUniqueS5Values(s5RoofMaterialData, s5AttachmentDictKeys.s_5_roof_material)
    if(selectedS5Panel === isGeneric){
      filteredRoofMaterialValues.unshift(isGeneric)
    }
    hasSelectedS5Panel = checkFieldNotEmpty(selectedS5Panel) && filteredRoofMaterialValues.length > 0;
    s5RoofMaterial = getS5RoofMaterial(filteredRoofMaterialValues)

    selectedS5Material = getS5DataValue(s5RoofMaterialData, s5AttachmentDictKeys.s_5_roof_material, s5_roof_material);
    const s5ClampData = filterDataByFields(s5RoofMaterialData, (selectedS5Material === isGeneric) ? '' : (selectedS5Manufacturer === isGeneric) ? {[s5AttachmentDictKeys.s_5_roof_material] : selectedS5Material} : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer, [s5AttachmentDictKeys.s_5_roof_panel_type] : selectedS5Panel, [s5AttachmentDictKeys.s_5_roof_material] : selectedS5Material})
    const filteredClampValues = extractUniqueS5Values(s5ClampData, s5AttachmentDictKeys.s_5_clamp)
    hasSelectedS5Material = checkFieldNotEmpty(selectedS5Material) && filteredClampValues.length > 0;
    s5Clamp = getS5Clamp(filteredClampValues)
  }

  let tornadoSpeedField: any = []
  let longestBuildingLengthField: any = []
  if (isASCE722(buildingCodeValue) && riskCategoryCheckForTornadoSpeed(risk_category)) {
    longestBuildingLengthField = longestBuildingLength(inputUnit, productId)
    longestBuildingLengthField.missing = !Boolean(building_length)
    tornadoSpeedField = isMetricUnit(inputUnit) ? metricTornadoSpeedField : tornadoSpeed;

  }
  const seismicSdsField = isASCE722(buildingCodeValue) ? seismicSds : [];

  checkEnvironmentalFactors(buildingCodeField, windSpeed, snowLoad, seismicSs, elevation);
  
  rafterSpacing.missing = isSMAscenderFlush(railsProductId) || isOsbOrPlywood(roof_type,attachment_type,roof_substrate) ? null: !checkRafterSpacing(Number(rafter_spacing_inches));
  preferredSpan.missing = !checkPreferredSpan(Number(preferred_span));
  seismicSs.missing = !checkSeismic(seismic_ss);
  buildingHeight.missing = !checkBuildingHeight(building_height * 1);
  shortestBuildingLength.missing = !checkShortestBuildingLength(shortest_building_length * 1);
  snowLoad.missing = !checkSnowLoadLimit(snow_load*1);
  roofType.missing = !checkRoofTypeMissing(roof_type);

  if(shouldShowS5AttachmentFields){
    s5RoofManufacturer.missing = !checkFieldNotEmpty(selectedS5Manufacturer);
    s5RoofPanel.missing = !checkFieldNotEmpty(selectedS5Panel);
    s5RoofMaterial.missing = !checkFieldNotEmpty(selectedS5Material);
    s5Clamp.missing = !checkFieldNotEmpty(s5_clamp);
  }
  s5Attachmentpreference.missing = !checkFieldNotEmpty(s5_or_sci);

  seismicSds.missing = !checkSeismicSds(seismic_sds);
  tornadoSpeed.missing = !checkTornadoSpeed(tornado_speed);
  elevation.missing = !checkFieldNotEmpty(current_elevation);
  riskCategory.missing = !checkFieldNotEmpty(risk_category);
  snowLoad.missing = !checkFieldNotEmpty(snow_load);
  windSpeed.missing = !checkFieldNotEmpty(wind_speed);
  domesticMLPERequired.missing = !checkFieldNotEmpty(state().projectConfiguration?.projectEnvConfig?.is_domestic_mlpe_required);
  domesticContent.missing = !checkFieldNotEmpty(domestic_content);
  topographicalFactorKzt.missing = !checkFieldNotEmpty(topographical_factor_kzt);

  const Helioscope = {
    fields: [
      azimuth,
      frameSizeUp,
      frameSizeWide,
      orientation,
      racking,
      smMidAndEndClamps('mid_clamps_choices','mid_clamps', true),
      smMidAndEndClamps('end_clamps_choices','end_clamps', true),
    ],
  };
  const Aurora = {
    fields: [
      auroraRackingType,
      smMidAndEndClamps('mid_clamps_choices','mid_clamps', true),
      smMidAndEndClamps('end_clamps_choices','end_clamps', true),
    ],
};
  const Os = {
    fields: [
      osRackingType,
      smMidAndEndClamps('mid_clamps_choices','mid_clamps', false, false, true),
      smMidAndEndClamps('end_clamps_choices','end_clamps', false, false, true),
      asce722BuildingCodeSM(false, false)
    ],
};
  const cfg = {
    zipCode: 'zipcode',
    Area: 'Peoria, AZ',
    Helioscope,
    Aurora,
    Os,
    Client: {
      label: '',
      fields: [
        clientName,
        clientAddress,
      ],
    },
    LocationAndLoads: {
      label: 'loads',
      fields: [
        buildingCodeField,
        windExposureField,
        windSpeed,
        snowLoad,
        elevation,
        seismicSs,
        seismicSdsField,
        ...getASCE716722LocationsResidentalAdditionalInputs(buildingCodeValue),
        topographicalFactorKzt,
        tornadoSpeedField,
      ],
    },
    BuildingDescription: {
      label: 'Building description',
      fields: [
        buildingHeight,
        ...(isSMAscenderFlush(railsProductId) ? [
          ascenderMidAndEndClamps('mid_clamps_choices'),
          ascenderMidAndEndClamps('end_clamps_choices'),
        ] : [
          smMidAndEndClamps('mid_clamps_choices','mid_clamps', false, is_aurora_project),
          smMidAndEndClamps('end_clamps_choices','end_clamps', false, is_aurora_project),
        ]),
        ...(isSMAscenderFlush(railsProductId) ? [smAscenderFlushRoofType] : [smFlushRoofType]),
        ...(roof_type === RoofType.STANDING_SEAM ? [s5Attachmentpreference] : []),
        ...(shouldShowS5AttachmentFields ? [s5RoofManufacturer]: []),
        ...(shouldShowS5AttachmentFields && hasSelectedS5Manufacturer ? [s5RoofPanel] : []),
        ...(shouldShowS5AttachmentFields && hasSelectedS5Manufacturer && hasSelectedS5Panel ? [s5RoofMaterial] : []),
        ...(shouldShowS5AttachmentFields && hasSelectedS5Manufacturer && hasSelectedS5Panel && hasSelectedS5Material ? [s5Clamp] : []),
        ...(([RoofType.SHINGLE, RoofType.OTHERS] as number[]).includes(roof_type) ? [smAndNxtAttachmentTypes(roof_type, productId)] : []) ,
        ...(roof_type === RoofType.SHINGLE  && [AttachmentType.FLASHLOC_DUO, AttachmentType.SM_BUTYL_DTD].includes(attachment_type)? [roofSubstrate(productId,attachment_type,roof_substrate,roof_type)] : []) ,
        isStaff || permissions.includes(PSEUDO_STAFF_USER_PERMISSIONS.staggering_access)?StaggerAttachments: [],
        ...((roof_type === RoofType.STANDING_SEAM && s5_or_sci == s5AttachmentPreferenceDict.sci) ? [roofMaterialThicknessSolarMountFlush,smStandardSeamMetalAttachment] : []) ,
        ...(roof_type === RoofType.R_PANEL ? [smAndNxtAttachmentTypes(roof_type, productId)] : []) ,
        ...(roof_type === RoofType.R_PANEL && attachment_type === AttachmentType.PM_9000S ? [rpanelRoofMaterialThicknessForPM9000s] : []) ,
        ...(roof_type === RoofType.R_PANEL && attachment_type === AttachmentType.PM_ADJUST ? [rpanelRoofMaterialThicknessForPMAdj] : []) ,
        ...(roof_type === RoofType.TILE  ? [smTileReplacementsOrSolarhooks()] : []) ,
        ...(roof_type === RoofType.TILE && tile_replacement_or_solarhooks === TileAttachmentType.SOLARHOOKS ? [smSolarhooksAttachments] : []) ,
        ...(roof_type === RoofType.TILE && tile_replacement_or_solarhooks === TileAttachmentType.STANDOFFS ? [standoffHeight] : []) ,
        ...(isASCE716or722(buildingCodeValue) && !isSMAscenderFlush(railsProductId) ? [residentalBuildingTypes, ...(isASCE722(buildingCodeValue) ? [longestBuildingLengthField] : []), shortestBuildingLength] : [shortestBuildingLength]),
        ...(isSM2Standard(railsProductId) || isSMLT(railsProductId) || isSMAscenderFlush(railsProductId) ? [domesticMLPERequired] : []),
      ],
    },
    Spans: {
      label: '',
      fields: [
        preferredSpan,
        ...(isOsbOrPlywood(roof_type,attachment_type,roof_substrate) ? [] : [rafterSpacing]),
      ],
    },
    railDirection: railDirection(removeUpslopeRail(attachment_type, projectVersion)),
    railFinish,
    railTypes: true,
  };

  return cfg;
};
